import { DDI, Device, ROUTE_START } from "callable-data-objects";
import { useDDI, useDevice } from "Hooks/Endpoints";
import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Container,
  Header,
  Icon,
  Label,
  Segment,
  Table,
} from "semantic-ui-react";

const InboundFlowDDIs = () => {
  const { ddis } = useDDI();
  const { devices, device, update } = useDevice();
  const [availableDDIs, setAvailableDDIs] = useState<DDI[]>([]);

  useEffect(() => {
    if (ddis && devices && device) {
      const takenDDIS = devices
        .filter((d: Device) => d.type === ROUTE_START && d.id !== device.id)
        .flatMap((d: Device) => d.startRoute.ddis);
      const avail = ddis.filter((ddi: DDI) => takenDDIS.indexOf(ddi.id) === -1);
      setAvailableDDIs(avail);
    }
  }, [device, devices, ddis]);

  async function disconnect(ddi: DDI) {
    if (device) {
      device.startRoute.ddis = device.startRoute.ddis.filter(
        (id: string) => id !== ddi.id
      );
      update(device);
    }
  }

  async function connect(ddi: DDI) {
    if (device) {
      device.startRoute.ddis.push(ddi.id);
      update(device);
    }
  }

  if (!device) return <Fragment />;

  const { startRoute } = device;

  if (availableDDIs.length === 0) {
    return (
      <Segment placeholder>
        <Header icon>
          <Icon name='warning circle' />
          No numbers are available to assign to this flow.
        </Header>
        {/* <Button primary>Add Document</Button> */}
      </Segment>
    );
  }
  return (
    <Container fluid>
      <Table celled padded stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1} singleLine></Table.HeaderCell>
            <Table.HeaderCell width={14} singleLine>
              Inbound Number
            </Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {availableDDIs.map((ddi: DDI) => (
            <Table.Row key={`tr-${ddi.id}`}>
              <Table.Cell singleLine>
                {startRoute?.ddis && startRoute.ddis?.indexOf(ddi.id) > -1 ? (
                  <Label color='blue' ribbon>
                    Selected
                  </Label>
                ) : (
                  ""
                )}
              </Table.Cell>
              <Table.Cell singleLine>{ddi.name}</Table.Cell>
              <Table.Cell singleLine>
                {startRoute?.ddis?.indexOf(ddi.id) > -1 ? (
                  <Button
                    size='tiny'
                    color='red'
                    onClick={() => disconnect(ddi)}
                  >
                    Disconnect
                  </Button>
                ) : (
                  <Button size='tiny' color='blue' onClick={() => connect(ddi)}>
                    Connect
                  </Button>
                )}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default InboundFlowDDIs;
